import React, { useEffect, useState } from 'react';

const TaskIconRenderer: React.FC<{ iconName: string }> = ({ iconName }) => {
  const [iconSrc, setIconSrc] = useState<string | null>(null);

  useEffect(() => {
    const loadIcon = async () => {
      try {
        const importedIcon = await import(
          `../../../assets/icons/tasks/${iconName}.svg`
        );
        setIconSrc(importedIcon.default);
      } catch {
        const defaultIcon = await import(`../../../assets/icons/tasks/key.svg`);
        setIconSrc(defaultIcon.default);
      }
    };
    loadIcon();
  }, [iconName]);

  return iconSrc ? (
    <img src={iconSrc} alt={iconName} className="w-8 h-8" />
  ) : null;
};

export default TaskIconRenderer;
